module.exports = __webpack_public_path__ + "static/media/Mr Good Evil.5cf8e66c.jpg";